function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConscentLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    width: 66.849,
    height: 10.315,
    viewBox: "0 0 66.849 10.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 911"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 149",
    d: "M8.142 10.024q-3.241.291-5.376.291a2.864 2.864 0 0 1-2.094-.667A2.849 2.849 0 0 1 0 7.561V2.908A3.018 3.018 0 0 1 .69.7 3.093 3.093 0 0 1 2.908 0h5.234v2.034H3.49a.771.771 0 0 0-.872.871v4.656a.717.717 0 0 0 .2.53.679.679 0 0 0 .5.2c.2 0 .426 0 .668-.007s.494-.012.756-.022l.792-.029c.266-.009.61-.029 1.031-.057s.947-.064 1.577-.1z",
    style: {
      fill: "#1d2943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 150",
    d: "M166.216 22.105a6.193 6.193 0 0 0-1.745.29v5.448h-2.541v-7.7h2.252l.145.727a5.17 5.17 0 0 1 1.4-.661A4.46 4.46 0 0 1 166.94 20h.654a2.05 2.05 0 0 1 2.18 2.18v5.664h-2.54v-5.235a.5.5 0 0 0-.508-.508z",
    transform: "translate(-143.094 -17.674)",
    style: {
      fill: "#1d2943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 151",
    d: "M234.455 26.929q2.949.216 4.653.218a.5.5 0 0 0 .508-.508v-.514h-3.126a2.05 2.05 0 0 1-2.18-2.18v-.5a2.049 2.049 0 0 1 2.18-2.18h4.939v1.886h-4.071a.508.508 0 0 0 0 1.017h2.616a2.053 2.053 0 0 1 2.182 2.186v.582a2.04 2.04 0 0 1-2.182 2.173q-2.572 0-5.521-.291z",
    transform: "translate(-207.055 -18.787)",
    style: {
      fill: "#1d2943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 152",
    d: "M315.387 10.024q-3.24.291-5.375.291a2.864 2.864 0 0 1-2.094-.668 2.846 2.846 0 0 1-.668-2.094V2.908A3.018 3.018 0 0 1 307.94.7a3.091 3.091 0 0 1 2.217-.7h5.234v2.034h-4.653a.77.77 0 0 0-.871.871v4.656a.717.717 0 0 0 .2.53.679.679 0 0 0 .5.2c.2 0 .426 0 .668-.007s.494-.012.756-.022l.791-.029c.266-.009.611-.029 1.032-.057s.947-.064 1.576-.1z",
    transform: "translate(-271.511)",
    style: {
      fill: "#1d2943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 153",
    d: "M385.824 21.815a.514.514 0 0 0-.582.582v.8h2.469v-.8a.514.514 0 0 0-.582-.582zm4.14 5.883a49.575 49.575 0 0 1-5.084.291 2.048 2.048 0 0 1-2.18-2.173v-3.49A2.141 2.141 0 0 1 385.025 20h2.908a2.136 2.136 0 0 1 2.322 2.326v2.685h-5.012v.582a.5.5 0 0 0 .508.508q1.44 0 4.213-.218z",
    transform: "translate(-338.184 -17.674)",
    style: {
      fill: "#1d2943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 154",
    d: "M458.066 22.105a6.187 6.187 0 0 0-1.745.29v5.448h-2.541v-7.7h2.252l.145.727a5.17 5.17 0 0 1 1.4-.661 4.452 4.452 0 0 1 1.215-.209h.654a2.05 2.05 0 0 1 2.18 2.18v5.664h-2.543v-5.235a.488.488 0 0 0-.508-.5z",
    transform: "translate(-400.996 -17.674)",
    style: {
      fill: "#1d2943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 155",
    d: "M530.551 15.675a26.976 26.976 0 0 1-2.757.145 2.053 2.053 0 0 1-2.182-2.173v-3.71h-.872V7.975h.872l.29-1.745h2.252v1.745h1.817v1.962h-1.817v3.341a.5.5 0 0 0 .509.508h1.888z",
    transform: "translate(-463.702 -5.505)",
    style: {
      fill: "#1d2943"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 910"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 156",
    d: "M78.245 21.832h-.123a.514.514 0 0 0-.582.582v2.908a.514.514 0 0 0 .582.582h1.784l.368 1.961h-2.948A2.143 2.143 0 0 1 75 25.537V22.2a2.139 2.139 0 0 1 2.326-2.325h.555z",
    transform: "translate(-66.276 -17.559)",
    style: {
      fill: "#1d2943"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 157",
    d: "M111.038 21.832h1.789a.514.514 0 0 1 .582.582v2.908a.514.514 0 0 1-.582.582h-.127l.368 1.961h.56a2.139 2.139 0 0 0 2.325-2.324V22.2a2.139 2.139 0 0 0-2.325-2.325h-2.958z",
    transform: "translate(-97.797 -17.559)",
    style: {
      fill: "#1d2943"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 158",
    d: "M106.048 43.5a1.248 1.248 0 1 1-1.248 1.247 1.248 1.248 0 0 1 1.248-1.247z",
    transform: "translate(-92.61 -38.44)",
    style: {
      fill: "#f54a29",
      fillRule: "evenodd"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConscentLogoSmall);
export default __webpack_public_path__ + "static/media/conscentLogoSmall.76f60144.svg";
export { ForwardRef as ReactComponent };